
import type {
  AddCurrencyReq,
  BaseErrorResponse,
  EmptySuccessResponse,
  GetCurrencyRes,
  GetCurrenciesRes,
  UpdateCurrencyReq,
} from './data-contracts';
import type { RequestParams } from './http-client';
import { ContentType, HttpClient } from './http-client';


export default function useCurrency() {
  class Currency<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Currency
     * @name CurrencyControllerGetCurrencies
     * @summary Getting a list of currencies
     * @request GET:/api3/currency
     * @secure
     * @response `200` `GetCurrenciesRes`
     * @response `400` `BaseErrorResponse`
     */
    currencyControllerGetCurrencies = (
      query?: {
        /**
         * Including a rate in response
         * @example true
         */
        withRates?: boolean;
      },
      params: RequestParams = {},
    ) =>
      this.request<GetCurrenciesRes, BaseErrorResponse>({
        path: '/api3/currency',
        method: 'GET',
        query,
        secure: true,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Currency
     * @name CurrencyControllerCreateCurrency
     * @summary Creating a currency
     * @request POST:/api3/currency
     * @secure
     * @response `200` `GetCurrenciesRes`
     * @response `400` `BaseErrorResponse`
     */
    currencyControllerCreateCurrency = (data: AddCurrencyReq, params: RequestParams = {}) =>
      this.request<GetCurrencyRes, BaseErrorResponse>({
        path: '/api3/currency',
        method: 'POST',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Currency
     * @name CurrencyControllerUpdateCurrency
     * @summary Updating a currency
     * @request PUT:/api3/currency/{id}
     * @secure
     * @response `200` `GetCurrenciesRes`
     * @response `400` `BaseErrorResponse`
     */
    currencyControllerUpdateCurrency = (id: string, data: UpdateCurrencyReq, params: RequestParams = {}) =>
      this.request<GetCurrenciesRes, BaseErrorResponse>({
        path: `/api3/currency/${id}`,
        method: 'PUT',
        body: data,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      });

    /**
     * No description
     *
     * @tags Currency
     * @name CurrencyControllerDeleteCurrency
     * @summary Deleting a currency
     * @request DELETE:/api3/currency/{id}
     * @secure
     * @response `200` `EmptySuccessResponse`
     * @response `400` `BaseErrorResponse`
     */
    currencyControllerDeleteCurrency = (id: string, params: RequestParams = {}) =>
      this.request<EmptySuccessResponse, BaseErrorResponse>({
        path: `/api3/currency/${id}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      });
  }

  return new Currency();
}
